import React from 'react';

const tabs = [
  { id: 'home',       icon: '🏠', label: 'Inicio'   },
  { id: 'cuba',       icon: '🇨🇺', label: 'Cuba'    },
  { id: 'clicks',     icon: '⭐', label: 'CLICKs'   },
  { id: 'asesores',   icon: '🧠', label: 'Asesores' },
  { id: 'more',       icon: '☰',  label: 'Más'      },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'rgba(10,22,40,0.97)',
      borderTop: '1px solid var(--navy-border)',
      display: 'flex',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      zIndex: 100,
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {tabs.map(tab => {
        const isActive = active === tab.id;
        return (
          <button key={tab.id} onClick={() => onChange(tab.id)} style={{
            flex: 1, background: 'none',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 3,
            padding: '10px 0 8px', position: 'relative',
          }}>
            {isActive && (
              <div style={{
                position: 'absolute', top: 0, left: '25%', right: '25%',
                height: 2, background: 'var(--orange)',
                borderRadius: '0 0 4px 4px',
              }} />
            )}
            <span style={{
              fontSize: 20,
              filter: isActive ? 'none' : 'grayscale(0.6) opacity(0.5)',
              transform: isActive ? 'scale(1.1)' : 'scale(1)',
              transition: 'all 0.2s',
            }}>{tab.icon}</span>
            <span style={{
              fontSize: 10, fontWeight: isActive ? 700 : 400,
              color: isActive ? 'var(--orange)' : 'var(--muted)',
              letterSpacing: '0.3px',
            }}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
